import axios from "../../../lib/axios";
import { useCallback, useState } from "react";

// Custom Hooks
import useSetTokenState from "./useSetTokenState";

import useLocalStorage2 from "../../../hooks/useLocalStorage2";

const useRefreshToken = () => {
  const [loading, setLoading] = useState(false);
  const [storedValue, setValue] = useLocalStorage2("user_auth");

  const setToken = useSetTokenState();

  const refresh = useCallback(async () => {
    if (!storedValue) return;
    setLoading(true);
    // console.log("OldToken: ", storedValue);
    try {
      const res = await axios.get("/api/auth/refresh", {
        headers: {
          "Content-Type": "application/json",
          withCredentials: true,
          Authorization: `Bearer ${storedValue.accessToken}`,
        },
      });

      const authToken = {
        ...storedValue,
        accessToken: res.data?.access_token,
      };

      setToken(authToken);
      return res?.data?.access_token;
    } catch (error) {
      console.log(error?.response);
      if (error?.response?.status == 401) {
        setToken(null);
      }
    } finally {
      setLoading(false);
    }
  }, [storedValue]);

  return { refresh, loading };
};

export default useRefreshToken;
